import { inject, Injectable } from '@angular/core';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppUser } from '@web/csl-lib-models';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  getMyProfile(): Observable<AppUser> {
    return this.http.get<AppUser>(`${this.apiUrl}/users/me`);
  }

  saveMyProfile(profile: AppUser): Observable<AppUser> {
    return this.http.patch<AppUser>(`${this.apiUrl}/users/me`, profile);
  }

  getAccountActivityLog(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/users/me/accountActivity`);
  }

  notifyLogin(): Observable<void> {
    console.debug('AccountService.notifyLogin');
    return this.http.get<any>(`${this.apiUrl}/users/me/notifyLogin`);
  }

}
